import { getTranslationGroup } from '@/services/api';
import { ITranslationGroup } from '@d-id/types';
import { useQuery, UseQueryOptions } from 'react-query';
import { GET_TRANSLATION_GROUP_KEY } from './translationLibrary';

export const useGetTranslationGroup = (groupId: string, options?: UseQueryOptions<ITranslationGroup>) => {
    return useQuery<ITranslationGroup>([GET_TRANSLATION_GROUP_KEY, groupId], () => getTranslationGroup(groupId), options);
};
